/* script */
//
//
//
//
//
//
//

// Mixins
import action from './action';

// Components
import MailingLogDetailsModal from 'shared/ui/components/modals/MailingLogDetailsModal.vue';
import ModalForm from 'shared/ui/components/form-components/ModalForm.vue';

const BUILT_IN_COMPONENTS = {
    MailingLogDetailsModal,
    ModalForm
};

const __vue_script__ = {
    name: 'OpenModalAction',

    mixins: [action],

    props: {
        component: {
            type: String,
            required: true
        },

        props: {
            type: Object,
            required: true
        },

        label: {
            type: String,
            default: ''
        },

        classes: {
            type: String,
            default: ''
        },

        onDone: {
            type: Function,
            default: () => {}
        },

        cell: {
            type: Object,
            default: () => ({})
        },

        modalSize: {
            type: String,
            default: 'small'
        }
    },

    computed: {
        compiledLabel() {
            const label = this.action.label || this.label;
            return this.$te(label) ? this.$t(label) : label;
        },

        compiledClasses() {
            return `${this.action.classes} ${this.classes}`;
        },

        compiledProps() {
            const compileObject = (rawObject) => {
                const compiledObject = {};
                for (const [key, value] of Object.entries(rawObject)) {
                    if (typeof value === 'object') {
                        compiledObject[key] = compileObject(value);
                    } else {
                        compiledObject[key] = this.$utils.strings.compileWithObject(value, this.item);
                    }
                }
                return compiledObject;
            };

            return compileObject(this.props);
        }
    },

    methods: {
        openModal() {
            this.$modal.show(BUILT_IN_COMPONENTS[this.component], {
                event: this.event,
                item: this.item,
                ...this.compiledProps,
                onSave: () => this.onDone()
            },
            {
                classes: this.modalSize,
                height: 'auto'
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.compiledClasses,attrs:{"type":"button","href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.openModal.apply(null, arguments)}}},[(_vm.action.icon)?_c('i',{class:_vm.action.icon}):_vm._e(),_vm._t("before-label"),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.compiledLabel))]}),_vm._t("after-label")],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "OpenModalAction.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__